import { PictureOutlined, ShopOutlined } from '@ant-design/icons';

const gym = {
  id: 'group-gym',
  title: 'Gym Management',
  type: 'group',
  children: [
    {
      id: 'gym-onboarding',
      title: 'Gym Onboarding',
      type: 'item',
      url: '/gym/onboarding',
      icon: ShopOutlined
    },
    {
      id: 'gym-vertical-banners',
      title: 'Vertical Banners',
      type: 'item',
      url: '/gym/vertical-banner',
      icon: PictureOutlined
    }
  ]
};

export default gym;
